/*eslint-disable no-process-env, no-undef */
import React from 'react'
import ReactDOM from 'react-dom'
import { HashRouter as Router } from 'react-router-dom'
import App from './App'
import { unregister } from './registerServiceWorker'
import qs from 'qs'
import LogRocket from 'logrocket'
LogRocket.init('q4lyhh/adscore')
const {REACT_APP_ROOT_PATH} = process.env

// const ROOT_PATH = ''
// Handle mobile logins
const isFacebookMobileLogin = () => {
	let { pathname, hash } = window.location
	return pathname === `${REACT_APP_ROOT_PATH}/` && /^#\/?state=/.test(hash)
}

const parseMobileFbLogin = () => {
	const hash = qs.parse(window.location.hash)
	const state = hash['#/state'] || hash['#state']
	return {
		email: state.substring(7).slice(0,-1),
		token: hash.access_token
	}
}


const searchToObject = () => {
	// Handle the utm showing up after the hash
	const base = (/^#\/\?/.test(window.location.hash)) ? window.location.hash.substring(3) : window.location.search.substring(1)
	var pairs = base.split('&'),
		obj = {},
		pair,
		i
	for ( i in pairs ) {
		if ( pairs[i] === '' ) continue

		pair = pairs[i].split('=')
		obj[ decodeURIComponent( pair[0] ) ] = decodeURIComponent( pair[1] )
	}
	return obj
}

const redirectMobileFbLogin = () => {
	let {email, token} = parseMobileFbLogin()
	window.location = `${REACT_APP_ROOT_PATH}/#/?email=${email}&token=${token}`
}

const params = searchToObject()

const paidTrafficSource = (params) => {
	if(params.utm_source) {
		// Parse UTM codes
		if(/facebook/i.test(params.utm_source)) { return 'Facebook' }
		if(/twitter/i.test(params.utm_source)) { return 'Twitter' }
		if(/reddit/i.test(params.utm_source)) { return 'Reddit' }
		if(/instagram/i.test(params.utm_source)) { return 'Instagram' }
		if(/speaking|event/i.test(params.utm_source)) {
			return 'Event'
		}
		if(/linkedin/i.test(params.utm_source)) { return 'LinkedIn' }
	}
	return 'Organic'
}

const parseTrafficSource = (params) => {
	if(params.ref) {
		if(params.ref === 'producthunt') { return 'ProductHunt' }
	}
	if(params.utm_source) {
		if(/^sdr$/i.test(params.utm_source)) { return 'SDR' }
		// Parse UTM codes
		return 'Paid'
	}
	if(document.referrer) {
		if(/google\.com/i.test(document.referrer)) { return 'Google' }
		if(/reddit\.com/i.test(document.referrer)) { return 'Reddit' }
		if(/twitter\.com/i.test(document.referrer)) { return 'Twitter' }
		if(/instagram\.com/i.test(document.referrer)) { return 'Instagram' }
		if(/producthunt\.com/i.test(document.referrer)) { return 'ProductHunt' }
		if(/linkedin\.com/i.test(document.referrer)) { return 'LinkedIN' }
	}
	return 'Direct'
}

if(isFacebookMobileLogin()) {
	// we need to redirect with properly formatted details
	redirectMobileFbLogin(REACT_APP_ROOT_PATH)
} else {
	// Use BrowserRouter as our router. This uses the browser’s History API to create real URLs.
	// Use the Router to render our App component. This will allow us to create the routes we need inside our App component.
	ReactDOM.render(
		<Router>
			<App trafficSource={parseTrafficSource(params)} paidTrafficSource={paidTrafficSource(params)} />
		</Router>,
		document.getElementById('root')
	)
	unregister()
}



// WEBPACK FOOTER //
// ./src/index.js